import { Connector } from '@/features/connectors'
import { useCallback, useMemo } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { ApiRoutes } from '@/config/routes'
import { parseConnectorFormData } from '@knots/shared-frontend'

export const useConnector = (initial: Connector | undefined): Partial<Connector> => {
  const parseConnector = (connector: Connector & { formData?: any }) => {
    return {
      ...connector,
      formData: connector.formData ? parseConnectorFormData(connector.formData) : undefined,
    }
  }
  return useMemo(() => (initial ? parseConnector(initial) : { system: 'ZENDESK' }), [initial])
}

export const useHandleClose = (onClose: () => void) => {
  const queryClient = useQueryClient()

  return useCallback(async () => {
    onClose()
    await queryClient.invalidateQueries({ queryKey: [ApiRoutes.getConnectors] })
  }, [queryClient, onClose])
}
